var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useCallback, useEffect, useMemo, useState } from "react";
import { useRemoveFileMutation } from "@/store/api";
import UploadFile from "@/components/dev/upload";
import Input from "@mui/joy/Input";
/** <b>Composant en mode consultation/detail d'un champ de type file</b>*/
export default function FileFieldEdit(_a) {
    var _this = this;
    var fieldName = _a.fieldName, record = _a.record, onUpdate = _a.onUpdate, fieldMetadata = _a.fieldMetadata, moduleName = _a.moduleName, isOnStudio = _a.isOnStudio;
    var value = useMemo(function () {
        if (!record) {
            return;
        }
        return record[fieldName || ""] || (fieldMetadata === null || fieldMetadata === void 0 ? void 0 : fieldMetadata.default);
    }, [fieldName, record]);
    var _b = useState(), files = _b[0], setFiles = _b[1];
    var _c = useState(""), fileData = _c[0], setFileData = _c[1];
    var _d = useState(false), fileRemoved = _d[0], setFileRemoved = _d[1];
    var _e = useState(false), showUpload = _e[0], setShowUpload = _e[1];
    var isPhoto = fieldMetadata.type === "image";
    var isFile = fieldMetadata.type === "file";
    var _f = useState(null), uploadStatus = _f[0], setUploadStatus = _f[1];
    var _g = useState(null), fileContents = _g[0], setFileContents = _g[1];
    var _h = useState(""), labelUpload = _h[0], setLabelUpload = _h[1];
    useEffect(function () {
        if (value === "" || value == undefined) {
            setShowUpload(true);
        }
        else {
            setFileRemoved(true);
            if ((record === null || record === void 0 ? void 0 : record.filecontents) && record.filecontents.fileName) {
                var existingFile = new File([], record.filecontents.fileName);
                setFiles(existingFile);
            }
        }
        if (isPhoto) {
            setLabelUpload("select image");
        }
        else {
            setLabelUpload("Select file");
        }
    }, [value, record]);
    var removeFileMutation = useRemoveFileMutation()[0];
    var removeFile = function () { return __awaiter(_this, void 0, void 0, function () {
        var response, error_1;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _b.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, removeFileMutation({
                            module: moduleName,
                            id: record.id,
                        }).unwrap()];
                case 1:
                    response = _b.sent();
                    setShowUpload(true);
                    setFileRemoved(false);
                    record["filecontents"] = {};
                    onUpdate && onUpdate((_a = {}, _a[fieldName] = "", _a));
                    return [3 /*break*/, 3];
                case 2:
                    error_1 = _b.sent();
                    console.log(error_1);
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); };
    var onEntriesDroped = useCallback(function (acceptedFiles) {
        try {
            acceptedFiles.forEach(function (fileEntry) {
                var _a;
                var isValidFileType = isPhoto
                    ? (_a = fileEntry === null || fileEntry === void 0 ? void 0 : fileEntry.type) === null || _a === void 0 ? void 0 : _a.startsWith("image/")
                    : true;
                var file = fileEntry.file;
                var base64String = fileEntry.content;
                if (!isValidFileType) {
                    setUploadStatus("Error: Invalid file type.");
                    return;
                }
                setFiles(file);
                setUploadStatus("Uploading...");
                setFileData(base64String);
                var params = {
                    base64String: base64String,
                    fileName: fileEntry.name,
                };
                record["filecontents"] = params;
                record[fieldName] = file === null || file === void 0 ? void 0 : file.name;
                if (isFile) {
                    record["document_name"] = file === null || file === void 0 ? void 0 : file.name;
                    record[fieldName] = file === null || file === void 0 ? void 0 : file.name;
                }
                setUploadStatus("success");
                onUpdate && onUpdate(record);
            });
        }
        catch (error) {
            setUploadStatus("Error: Upload failed.");
        }
    }, [record]);
    return (_jsx("div", __assign({ className: "" }, { children: isOnStudio ? (_jsx(Input, { type: "text", className: "w-full" })) : (_jsxs(_Fragment, { children: [showUpload && (_jsx(UploadFile, { onEntriesDroped: onEntriesDroped, type: fieldMetadata.type, labelUpload: labelUpload })), (uploadStatus === null || uploadStatus === void 0 ? void 0 : uploadStatus.includes("Error")) ? (_jsx("span", __assign({ className: "pl-2 text-red-500" }, { children: uploadStatus }))) : (""), value && fileRemoved ? (_jsxs("div", __assign({ className: "p-1 flex flex-row justify-between" }, { children: [_jsx("span", __assign({ className: "w-[50%]" }, { children: value })), _jsx("span", __assign({ className: "pl-2 pt-1 cursor-pointer", onClick: removeFile }, { children: _jsx("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 24 24", strokeWidth: "1.5", stroke: "currentColor", className: "w-4 h-4 bg-red-300 rounded-sm  text-green-700" }, { children: _jsx("path", { strokeLinecap: "round", strokeLinejoin: "round", d: "M15 12H9m12 0a9 9 0 11-18 0 9 9 0 0118 0z" }) })) }))] }))) : (_jsx(_Fragment, { children: files && (_jsxs("div", __assign({ className: "flex border-2 rounded p-2 bg-emerald-200 flex-row justify-between" }, { children: [_jsx("span", __assign({ className: "w-[50%] overflow-hidden text-ellipsis" }, { children: files && (files === null || files === void 0 ? void 0 : files.name) })), _jsxs("span", __assign({ className: "pl-1" }, { children: [Math.round(files && (files === null || files === void 0 ? void 0 : files.size) / 1024), "KB"] })), _jsx("span", __assign({ className: "px-1" }, { children: (uploadStatus === null || uploadStatus === void 0 ? void 0 : uploadStatus.includes("success"))
                                    ? uploadStatus
                                    : "success" }))] }))) }))] })) })));
}
